import { useEffect } from 'react';

type Meta = {
  title: string;
  description?: string;
};

export function useDocumentMeta({ title, description }: Meta) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title;

    let descEl = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]'
    );
    const prevDesc = descEl?.content;
    if (description) {
      if (!descEl) {
        descEl = document.createElement('meta');
        descEl.name = 'description';
        document.head.appendChild(descEl);
      }
      descEl.content = description;
    }

    return () => {
      document.title = prevTitle;
      if (descEl && prevDesc !== undefined) descEl.content = prevDesc;
    };
  }, [title, description]);
}
